// Copyright (c) 2016 Deere & Company

import React, {PropTypes} from 'react';
import {FormattedMessage} from 'react-intl';
import {Link} from 'react-router';
import TabState from '../../state/tab';
import {buildNumber} from '../../services/build-number';

const Tab = props =>
    <Link
        activeClassName='active-tab'
        className='tab-name'
        to={props.tab.route}
    >
        <FormattedMessage
            id={props.tab.label}
            values={{
                count: buildNumber(props.tab.count)
            }}
        />
    </Link>;

Tab.displayName = 'Tab';
Tab.propTypes = {
    tab: PropTypes.instanceOf(TabState).isRequired
};

export default Tab;



// WEBPACK FOOTER //
// ./src/shared/components/tab-navigation/tab.js